import { ENDPOINTS, endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createEventCategory = (_, payload) => {
  return Api(ENDPOINTS.EVENT_CATEGORY.CREATE, payload, requestType.POST);
};

const updateEventCategory = (id, payload) => {
  return Api(
    ENDPOINTS.EVENT_CATEGORY.UPDATE.replace(":id", id),
    payload,
    requestType.PUT,
  );
};

const getEventCategoryById = (id) => {
  return Api(
    ENDPOINTS.EVENT_CATEGORY.GET_BY_ID.replace(":id", id),
    null,
    requestType.GET,
  );
};

const getEventCategoryBySlug = (slug) => {
  return Api(
    ENDPOINTS.EVENT_CATEGORY.GET_BY_SLUG.replace(":slug", slug),
    null,
    requestType.GET,
  );
};

const getEventCategories = (params = {}) => {
  const ENDPOINT = ENDPOINTS.EVENT_CATEGORY.GET_ALL;

  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const finalUrl = queryParams.toString()
    ? `${ENDPOINT}?${queryParams.toString()}`
    : `${ENDPOINT}`;

  return Api(finalUrl, null, requestType.GET);
};

export {
  createEventCategory,
  updateEventCategory,
  getEventCategoryById,
  getEventCategoryBySlug,
  getEventCategories,
};
